import { render, staticRenderFns } from "./cardAssistant.vue?vue&type=template&id=16cc220d&scoped=true"
import script from "./cardAssistant.vue?vue&type=script&lang=js"
export * from "./cardAssistant.vue?vue&type=script&lang=js"
import style0 from "./cardAssistant.vue?vue&type=style&index=0&id=16cc220d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cc220d",
  null
  
)

export default component.exports